module.exports = __webpack_public_path__ + "static/media/desktop-icon-12-r-track-laptime.42560a79.svg";